import React from 'react';
import cn from 'classnames';
import style from './style.scss';

const Footer = () => (
  // Global Footer
  <div id="Footer" className={cn('portal-footer', style.portalFooter)} data-sticky-footer>
    <div className="footer-content">
      <p className="p-small">All loans are made by Cross River Bank, a New Jersey State Chartered Bank. Member FDIC. Loan amounts range from $1,000 to $35,000. No loans are offered in <span className={style.cities}>CT, NY, WV, NH, VT, KS, MS, SC, WA, WI, VI, PR and WY</span>. The APR’s range from 25.70% APR to 29.99% APR. An origination fee of 8% is included in the principal loan amount that results in an APR up to 29.99%.</p>
    </div>
  </div>
  // End Global Footer
);

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/index.js